export default __webpack_public_path__ + "static/splash-0db5ca4cc3ca9e37a1b5238bba094d8c.svg";